import Swiper from 'swiper/bundle';

const slider = () => {
  const sliders = document.querySelectorAll('[data-slider]');

  if (sliders.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < sliders.length; i++) {
      const options = sliders[i].getAttribute('data-slider-options')
        ? JSON.parse(sliders[i].getAttribute('data-slider-options'))
        : {};
      options.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };
      // eslint-disable-next-line no-unused-vars
      const swiper = new Swiper(sliders[i], options);
    }
  }
};

export default slider;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/slider.js